<div class="particles" #ParticlesWrapper>
  <div class="particles-background">
    <canvas #ParticlesCanvas></canvas>
  </div>

  <ng-content></ng-content>
</div>